import { FAQJsonLd } from 'gatsby-plugin-next-seo'
import PropTypes from 'prop-types'
import React from 'react'
import { renderToString } from 'react-dom/server'

import { renderRichTextWithOptions } from './Content'

function FAQSeo({ questions }) {
  return (
    <FAQJsonLd
      questions={questions.map(({ name, answer }) => ({ question: name, answer: renderToString(renderRichTextWithOptions(answer)) }))}
    />
  )
}

FAQSeo.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    answer: PropTypes.shape({
      raw: PropTypes.string.isRequired
    }).isRequired
  })).isRequired
}

export default FAQSeo
